import { Autocomplete, Checkbox, FormControlLabel, Grid, Paper, TextField } from '@mui/material'
import type { ManufacturerFilters as ManufacturerFiltersType } from './ManufacturerList.types'

export interface ManufacturerFiltersProps {
  filters: ManufacturerFiltersType
  onFiltersChange: (filters: ManufacturerFiltersType) => void
  manufacturerOptions: string[]
}

export function ManufacturerFilters({ filters, onFiltersChange, manufacturerOptions }: ManufacturerFiltersProps) {
  const updateFilter = (key: keyof ManufacturerFiltersType, value: string | boolean) => {
    onFiltersChange({ ...filters, [key]: value })
  }

  return (
    <Paper
      elevation={0}
      sx={{
        mx: 2,
        mt: 2,
        mb: 2,
        px: 2,
        py: 2,
        background: '#fff',
        boxShadow: '0 4px 4px 0 rgba(0,0,0,0.25)',
        borderRadius: 1,
      }}
    >
      <form onSubmit={e => e.preventDefault()}>
        <Grid container spacing="24px" alignItems="center">
          <Grid size={3}>
            <Autocomplete
              options={manufacturerOptions}
              value={filters.manufacturer || null}
              onChange={(_event, newValue) => updateFilter('manufacturer', newValue ?? '')}
              clearOnEscape
              renderInput={params => <TextField {...params} label="Manufacturers" size="small" fullWidth />}
            />
          </Grid>

          <Grid size={2.5}>
            <TextField
              fullWidth
              size="small"
              label="Alias"
              value={filters.alias}
              onChange={e => updateFilter('alias', e.target.value)}
            />
          </Grid>

          <Grid size={2.5}>
            <TextField
              fullWidth
              size="small"
              label="OEM Code"
              value={filters.oemCode}
              onChange={e => updateFilter('oemCode', e.target.value)}
            />
          </Grid>

          <Grid size={3}>
            <TextField
              fullWidth
              size="small"
              label="URL"
              value={filters.url}
              onChange={e => updateFilter('url', e.target.value)}
            />
          </Grid>

          <Grid size={1}>
            <FormControlLabel
              sx={{ m: 0, whiteSpace: 'nowrap' }}
              label="Direct"
              control={
                <Checkbox
                  checked={filters.direct}
                  onChange={e => updateFilter('direct', e.target.checked)}
                  size="small"
                />
              }
            />
          </Grid>
        </Grid>
      </form>
    </Paper>
  )
}
